<script setup lang="ts"></script>

<template>
  <icon name="lucide:circle-help" />
</template>

<style scoped></style>
